import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { VehicleWatchContactModel } from '../../vehicle/models/vehicle-watch-contact.model';
import { VehicleOwnershipModel } from '../models/vehicle-ownership.model';
import { VehicleAddressModel } from '@max/vehicle/models/vehicle-address.model';

@Injectable()
export class OwnershipService extends BaseApiService {
    getActiveOwnership = (vehicleId: number): Observable<VehicleOwnershipModel> => this.get('TitleRegistration/Ownership/Vehicle/' + vehicleId);

    getOwnershipInquiry = (vehicleOwnershipId: number) => this.get('TitleRegistration/Ownership/' + vehicleOwnershipId + '/Inquiry');

    getOwnershipsByVehicleId = (vehicleId: number) => this.get('TitleRegistration/Ownership/Vehicle/' + vehicleId + '/All');

    getVehicleWatchContact(vehicleId: number) {
        return this.get('TitleRegistration/Ownership/VehicleWatchContact/' + vehicleId);
    }

    updateVehicleWatchContact = (model: VehicleWatchContactModel, vehicleId: number) => this.post('TitleRegistration/Ownership/VehicleWatchContact/' + vehicleId, model);

    updateVehicleAddress = (model: VehicleAddressModel) => this.post('TitleRegistration/Ownership/VehicleAddress/', model);

    deleteVehicleWatchContact = (vehicleId: number) => this.delete('TitleRegistration/Ownership/VehicleWatchContact/' + vehicleId);

    canEditVehicleWatchContact = (vehicleId: number) => this.get('TitleRegistration/Ownership/VehicleWatchContact/CanEdit/' + vehicleId);
    getPrimaryCustomerNumberId = (vehicleId: number) => this.get('TitleRegistration/Ownership/' + vehicleId + '/PrimaryCustomerNumberId');

    getDomicileAddressByVehicleOwnershipId(vehicleOwnershipId: number) {
        return this.get('TitleRegistration/Ownership/DomicileAddress/' + vehicleOwnershipId);
    }
}
